module.exports = __webpack_public_path__ + "static/home-intro-low.c271642f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/welcome-block/home-intro-low.jpg
// module id = 126
// module chunks = 35783957827783 122595392396565